<tlk-listbox
	*ngIf="items.length"
	class="rx-intuitive-art-treatment-viewlist__listbox"
	[size]="'l'"
	[multiple]="false"
	[hideSelectionIndicator]="true"
	[formControl]="selectedListOptionControl"
>
	<ng-container *ngFor="let item of items; trackBy: trackByItem" ngProjectAs="tlk-listbox-option">
		<tlk-card [padding]="cardPadding" class="rx-intuitive-art-treatment-viewlist__card">
			<tlk-listbox-option
				tlkCardContent
				[value]="trackByItem(0, item)"
				class="rx-intuitive-art-treatment-viewlist__option"
			>
				<rx-intuitive-art-treatment-viewlist-item
					[item]="item"
					[chartReadOnly]="chartReadOnly"
					(resetRequested)="onResetRequested($event)"
				/>
			</tlk-listbox-option>
		</tlk-card>
	</ng-container>
</tlk-listbox>
